// extracted by mini-css-extract-plugin
export default {"noResults":"no-input_noResults__zz+x9"};